import React, { useEffect, useState } from "react";
import axios from "axios";
import "../CSS/IssueForm.css";
import "../CSS/Message.css";
import IssueLoaderButton from "./pageLoaders/IssueLoaderButton";
import PageLoader from "./pageLoaders/PageLoader";

const IssueForm = ({
  onSubmit,
  setShowForm,
  setTicketId,
  ticketId,
  loading,
  setLoading,
  widgetConfigs,
  setupDetails,
}) => {
  const [formData, setFormData] = useState({});
  const [formConfigs, setFormConfigs] = useState(null);
  const [isFormConfigLoading, setIsFormConfigLoading] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(null);

  useEffect(() => {
    setCustomerDetails(
      JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details"))
    );
  }, []);

  useEffect(() => {
    if (formConfigs) {
      // Initialize form data with default values from form config
      const initialData = {};
      formConfigs.fields.forEach((field) => {
        initialData[field.name] = field.defaultValue || "";
      });
      setFormData(initialData);
    }
  }, [formConfigs]);

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (type === "file") {
      setFormData((prevData) => ({
        ...prevData,
        attachments: [...(prevData.attachments || []), ...Array.from(files)],
      }));
    } else if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleDeleteAttachment = (index) => {
    setFormData((prevData) => {
      const newAttachments = [...prevData.attachments];
      newAttachments.splice(index, 1);
      return { ...prevData, attachments: newAttachments };
    });
  };

  const token = localStorage.getItem("dexkor-chat-widget-auth-token");

  useEffect(() => {
    if (ticketId) {
      onSubmit(formData);
    }
  }, [ticketId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/tickets/create`,
        {
          uniquePartnerId: widgetConfigs.uniquePartnerId,
          customFields: formData,
          source: "widget",
          cc: [
            {
              name: formData.name,
              address: customerDetails?.email || formData?.email,
            },
          ],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTicketId(response.data._id);
      setLoading(false);
    } catch (error) {
      console.error("Error occurred while submitting form:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    setIsFormConfigLoading(true);
    const getTicketForm = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/widget/ticket-form/${widgetConfigs.uniquePartnerId}`
        );
        setFormConfigs(response?.data?.data);
        setIsFormConfigLoading(false);
      } catch (error) {
        console.error("Error fetching form config:", error);
        setIsFormConfigLoading(false);
      }
    };
    getTicketForm();
  }, [widgetConfigs.uniquePartnerId]);

  console.log({ formConfigs });

  const renderField = (field) => {
    const commonProps = {
      id: field.name,
      name: field.name,
      value: formData[field.name] || "",
      onChange: handleChange,
      className: "dexkor-form-input",
      required: field.required,
      placeholder: field.label,
    };

    switch (field.fieldType) {
      case "text":
      case "email":
      case "number":
        return (
          <input
            type={field.fieldType}
            {...commonProps}
            minLength={field.validation?.min}
            maxLength={field.validation?.max}
          />
        );

      case "textarea":
        return (
          <textarea
            {...commonProps}
            className="dexkor-form-input-textarea"
            rows={4}
            minLength={field.validation?.min}
            maxLength={field.validation?.max}
          />
        );

      case "select":
        return (
          <select {...commonProps} className="dexkor-form-input py-1">
            <option value="">
              {field.defaultValue || `Select ${field.label}`}
            </option>
            {field.options.map((option) => (
              <option key={option._id} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );

      case "checkbox":
        return (
          <div className="flex items-center">
            <input
              type="checkbox"
              {...commonProps}
              checked={formData[field.name] || false}
              className="mr-2"
            />
            <label>{field.label}</label>
          </div>
        );

      case "date":
        return <input type="date" {...commonProps} />;

      default:
        return null;
    }
  };

  if (isFormConfigLoading) {
    return (
      <div>
        <PageLoader />
      </div>
    );
  }

  if (!formConfigs) {
    return <div>Unable to load form configuration</div>;
  }

  return (
    <div className="p-4 mt-0 dexkor-scrollable-form">
      <h2
        className="dexkor-issue-header"
        style={{ color: setupDetails?.widgetCustomizations.primaryColor }}
      >
        {formConfigs.name || "Create ticket"}
      </h2>

      <form className="space-y-5 mt-4" onSubmit={handleSubmit}>
        <div className="dexkor-form-grid">
          {/* Render dynamic fields */}
          {formConfigs.fields
            .sort((a, b) => a.order - b.order)
            .map((field) => (
              <div
                key={field._id}
                className={`mb-2 ${
                  field.fieldType === "textarea" ? "dexkor-form-full-width" : ""
                }`}
              >
                <label className="flex items-start">{field?.label}</label>
                {renderField(field)}
              </div>
            ))}

          {/* Static attachments field */}
          {/* <div className="mb-4 dexkor-form-full-width"> */}
          {/* <div className="flex items-center justify-center w-full">
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50"
              >
                <div className="flex flex-col items-center justify-center pt-3 pb-4">
                  <div className="flex items-center justify-center space-x-2">
                    <svg
                      className="w-5 h-5 mb-2 text-gray-500"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500">
                      <span className="font-semibold">Click to upload</span>
                    </p>
                  </div>
                  <p className="text-xs text-gray-500">
                    SVG, PNG, JPG or PDF (MAX. 5mb)
                  </p>
                </div>
                <input
                  id="dropzone-file"
                  type="file"
                  name="attachments"
                  onChange={handleChange}
                  className="hidden"
                  multiple
                />
              </label>
            </div> */}

          {/* Display selected attachments */}
          {/* <div className="mt-2">
              {formData.attachments?.map((file, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between mb-1"
                >
                  <span className="text-sm text-gray-700">{file.name}</span>
                  <button
                    type="button"
                    onClick={() => handleDeleteAttachment(index)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <IoTrashOutline className="h-5 w-5" />
                  </button>
                </div>
              ))}
            </div> */}
          {/* </div> */}
        </div>
        <div className="flex justify-end space-x-6">
          {loading ? (
            <IssueLoaderButton />
          ) : (
            <>
              <button
                onClick={() => setShowForm(false)}
                className="dexkor-issue-cancel-button"
                style={{
                  color: setupDetails?.widgetCustomizations.primaryColor,
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="dexkor-issue-submit-button"
                style={{
                  background: setupDetails?.widgetCustomizations.primaryColor,
                }}
              >
                Submit
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default IssueForm;
